/* istanbul ignore file */
import { observable, action, computed } from 'mobx';
import { reportError } from '@elevio/elevio-frontend-utils/dist/diagnostics';

const CUSTOM_FORM_MODULE_ID = 36;

export default class Settings {
  @observable cuid;
  @observable id;
  @observable locales;
  @observable language;
  @observable externalNavigation = false;
  canGoBack = false;
  goBack = () => {};
  @observable child;

  constructor(testStubs, shouldReport = true) {
    this.testStubs = testStubs;
    this.shouldReport = shouldReport;
    this.configure();
  }

  @action
  configure() {
    let Child;
    let stubs;
    if (
      process.env.NODE_ENV === 'development' ||
      process.env.NODE_ENV === 'test'
    ) {
      Child = require('@elevio/elevio-postman/child-mock').default; // eslint-disable-line global-require
      stubs = {
        0: ['account_id', 'konami'],
        1: ['addon_id', CUSTOM_FORM_MODULE_ID],
        3: [
          'user',
          {
            first_name: 'Chloe',
            last_name: 'Phua',
            user_hash:
              '808d09ff293f6719af76c3ec198b8fa8031c1405e5d5adf4487abf907db998a2',
            email: 'chloe@elev.io',
            groups: ['elevio', 'beta1'],
            registered_at: 1485988381000,
            traits: {
              Plan: 'elevio',
              tags: ['elevio', 'Active'],
              emptyCheck: false,
            },
          },
        ],
        6: ['capabilities', { externalNavigation: false }],
        // 7: ['language', 'es-419'],
      };
      // Child = require('@elevio/elevio-postman/child-mock').default;
    } else {
      stubs = undefined;
      Child = require('@elevio/elevio-postman/child').default; // eslint-disable-line global-require
    }
    this.child = new Child(
      () => {},
      err => {
        if (this.shouldReport) reportError('Child Error', err);
      },
      this.testStubs || stubs
    );

    this.child.on((type, data) => {
      if (type === 'navigation') {
        if (!this.canGoBack) {
          this.child.send('navigation-reply', false);
        } else {
          this.child.send('navigation-reply', true);
          this.goBack();
        }
        return;
      }
      if (type === 'storage' && process.env.NODE_ENV !== 'test') {
        let parsed = data;

        if (typeof data === 'string') {
          parsed = JSON.parse(data);
        }

        const formSession = parsed.find(e => e.key === 'form');
        this.formStore.resolveStorage(formSession ? formSession.data : {});

        if (formSession) {
          const d = formSession.data;
          if (d.storedValuesString.length) {
            this.formStore.setValuesFromSession(d.storedValuesString);
            if (this.router) {
              this.router.replace('/');
            }
          }
        }
      }

      switch (type) {
        case 'settings':
          this.parentSettings = data;
          break;
        case 'user':
          this.user = Object.assign({}, this.user, {
            firstname: data.first_name,
            lastname: data.last_name,
            email: data.email,
            userHash: data.user_hash,
            traits: data.traits,
            groups: data.groups,
            authenticated: data.isLoggedIn,
          });
          break;
        case 'capabilities':
          this.externalNavigation = data.externalNavigation;
          break;
        case 'account_id':
          this.cuid = data;
          break;
        case 'addon_id':
          this.id = data;
          break;
        case 'language':
          this.language = data;
          break;
        case 'localization':
          this.locales = data;
          break;
        default:
          break;
      }
    });
  }

  @action
  setGoBackCapability = can => {
    this.canGoBack = can;
  };

  @action
  setGoBackFunction = backFunction => {
    this.goBack = backFunction;
  };

  @computed
  get isLoading() {
    return !(this.cuid && this.id && this.locales && this.language);
  }

  @action
  navigateArticle = id => {
    this.child.send('navigate-article', {
      id,
    });
  };

  @action
  setRouter = router => {
    this.router = router;
  };

  @action
  trackEvent = (name, props = {}) => {
    this.child.send(
      'analytics',
      Object.assign(
        {},
        {
          event_name: name,
          user_email: this.user && this.user.email ? this.user.email : '',
        },
        props
      )
    );
  };
}



// WEBPACK FOOTER //
// ./src/stores/settings.js